// extracted by mini-css-extract-plugin
export default {"container":"MarketingWarningPage_container__aIpBh","contentContainer":"MarketingWarningPage_contentContainer__9-8VD","textLine":"MarketingWarningPage_textLine__wxhdn"};